





























































































import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import { rules } from "../services/validation";
import * as types from "../store/types";

export default Vue.extend({
  name: "RegisterPage",

  metaInfo() {
    return {
      title: "Register | ARPA Small Business - Greene County, MO",
    };
  },

  data() {
    return {
      rules: {
        ...rules,
      },
      formValue: {
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        password: "",
        passwordConfirm: "",
      },
    };
  },

  computed: {
    ...mapGetters({
      loggedIn: types.IS_LOGGED_IN,
      submitting: types.SUBMITTING_REGISTRATION,
      errorMessage: types.REGISTER_ERROR,
      applications: types.APPLICATIONS_LIST,
      user: types.USER,
    }),
  },

  methods: {
    ...mapActions({
      register: types.REGISTER,
      login: types.LOGIN,
      listApplications: types.LIST_USER_APPLICATIONS,
    }),
    passwordsMatchRule(): boolean {
      return (this.formValue.password.length === 0 ||
        this.formValue.passwordConfirm.length === 0 ||
        this.formValue.password == this.formValue.passwordConfirm ||
        "Passwords do not match.") as boolean;
    },
    submit() {
      // @ts-ignore
      if (!this.$refs.form.validate()) return;

      this.register(this.formValue);
    },
  },

  watch: {
    applications: {
      immediate: true,
      handler() {
        if (this.loggedIn && this.applications.length > 0) {
          this.$router.push({
            path: "/application/" + this.applications[0].id,
          });
        }
      },
    },
  },
});
